// extracted by mini-css-extract-plugin
export default {"editor":"SnippetModal_editor__ugaf9"};